module.exports = __webpack_public_path__ + "promo/app-store-badges/apple-app-store-de-eedb5192f67f0987871047d5617161e6.svg";


//////////////////
// WEBPACK FOOTER
// ./images/promo/app-store-badges/apple-app-store-de.svg
// module id = 4uaO
// module chunks = 22